<ngx-smart-modal #myModal1 identifier="myModal1">
    <h2 class="modalError">Please login and subscribe to access this content.</h2>
    <button class="modalErrorButton" (click)="myModal1.close()" routerLink="/login">Login Now</button>
  </ngx-smart-modal>
  <ngx-smart-modal #myModal2 identifier="myModal2">
    <h2 class="modalError">Oh No, something went wrong, please refresh the page.</h2>
    <button class="modalErrorButton" (click)="myModal2.close(); refresh()" >Refresh Now</button>
  </ngx-smart-modal><div class="loadingBox" *ngIf="!loaded">
    <img  class="pulsateBG" src="assets/img/hostbrand/core-whitelogo.svg" width="300">
   </div>
   <div *ngIf="loaded"><app-header></app-header>
<div id="wrapper">
    <app-sidebar></app-sidebar>
    <div id="content-wrapper">
        <div class="container-fluid">
            <div class="video-block section-padding">
                <div class="row">

                    <div *ngFor="let content of contenthistory.content, let i=index;" class="col-xs-6 col-sm-3 col-6 mb-3">
                        <div class="video-card history-video">
                            <div class="video-card-image" [class.educationImages]="isHeadStart"><a class="play-icon" routerLink="/play/{{content.currentContentView}}">
                                    <i class="fas fa-play-circle"></i>
                                </a>
                                <a routerLink="/play/{{content.currentContentView}}">
                                    <span *ngIf="content.contentImageUrl != null"><img class="img-fluid" src="{{content.contentImageUrl}}" alt=""></span><span *ngIf="content.contentImageUrl == null"><img class="img-fluid" src="https://s3.us-east-2.amazonaws.com/videyo-cdn/contentImages/defaults/content-default.png" alt=""></span>
                                </a>
                            </div>
                            <div class="video-card-body">
                                <div class="video-title">
                                    <a routerLink="/play/{{content.currentContentView}}">{{content.title}}</a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<div class="container-slider">
        <div class="navbarbottom">
          <a routerLink="/"><i _ngcontent-c3="" class="fas fa-fw fa-home"></i> <span class="homeFooterLink" i18n="@@Footer Home Link">Home</span></a>
          <a routerLink="/my-list"><i _ngcontent-c3="" class="fas fa-fw fa-list"></i> <span class="myListFooterLink" i18n="@@Footer My List Link">My List</span></a>
 
        </div>
        </div>
        </div>
